export class RePaySaleResponseModel {
  paymentData;
  paymentResponseData;
  constructor({paymentData,paymentResponseData}) {     
    this.paymentData = new RePayPaymentData(paymentData);
    this.paymentResponseData = new RepayPaymentResponseData(paymentResponseData);
  }
}

class RePayPaymentData {
  amount;
  card_expiration;
  card_last_four;
  cardholder_name;
  convenience_fee;
  customer_id;
  save_payment_method;
  transaction_type;
  first_name;
  last_name;
  customer_reference;
  paytoken;
  constructor({
    amount,
    card_expiration,
    card_last_four,
    cardholder_name,
    convenience_fee,
    customer_id,
    save_payment_method,
    transaction_type,
    first_name,
    last_name,
    customer_reference,
    paytoken,
  }) {
    this.amount = amount;
    this.card_expiration = card_expiration;
    this.card_last_four = card_last_four;
    this.cardholder_name = cardholder_name;
    this.convenience_fee = convenience_fee;
    this.customer_id = customer_id;
    this.save_payment_method = save_payment_method;
    this.transaction_type = transaction_type;
    this.first_name = first_name;
    this.last_name = last_name;
    this.customer_reference = customer_reference;
    this.paytoken = paytoken;
  }
}

class RepayPaymentResponseData {
  auth_amount;
  auth_code;
  avs_response_code;
  card_bin;
  customer_id;
  date;
  entry_method;
  host_ref_num;
  last4;
  manual;
  name_on_card;
  payment_method_detail;
  payment_type_id;
  pn_ref;
  requested_auth_amount;
  result;
  result_details;
  result_text;
  retry_count;
  reversed;
  settle_flag;
  success_data;
  tip_amount;
  total_amount;
  trans_type_id;
  trx_status;
  voided;
  constructor({
    auth_amount,
    auth_code,
    avs_response_code,
    card_bin,
    customer_id,
    date,
    entry_method,
    host_ref_num,
    last4,
    manual,
    name_on_card,
    payment_method_detail,
    payment_type_id,
    pn_ref,
    requested_auth_amount,
    result,
    result_details,
    result_text,
    retry_count,
    reversed,
    settle_flag,
    success_data,
    tip_amount,
    total_amount,
    trans_type_id,
    trx_status,
    voided,
  }) {
    this.auth_amount = auth_amount;
    this.auth_code = auth_code;
    this.avs_response_code = avs_response_code;
    this.card_bin = card_bin;
    this.customer_id = customer_id;
    this.date = date;
    this.entry_method = entry_method;
    this.host_ref_num = host_ref_num;
    this.last4 = last4;
    this.manual = manual;
    this.name_on_card = name_on_card;
    this.payment_method_detail = new RePayPaymentMethodDetail(
      payment_method_detail
    );
    this.payment_type_id = payment_type_id;
    this.pn_ref = pn_ref;
    this.requested_auth_amount = requested_auth_amount;
    this.result = result;
    this.result_details = new RePayResultDetails(result_details);
    this.result_text = result_text;
    this.retry_count = retry_count;
    this.reversed = reversed;
    this.settle_flag = settle_flag;
    this.success_data = success_data;
    this.tip_amount = tip_amount;
    this.total_amount = total_amount;
    this.trans_type_id = trans_type_id;
    this.trx_status = trx_status;
    this.voided = voided;
  }
}
class RePayPaymentMethodDetail {
  card_last_four;
  constructor({ card_last_four }) {
    this.card_last_four = card_last_four;
  }
}
class RePayResultDetails {
  authorization_reversed;
  card_info;
  delayed_in_reporting;
  constructor({ authorization_reversed, card_info, delayed_in_reporting }) {
    this.authorization_reversed = authorization_reversed;
    this.card_info = new RePayCardInfo(card_info);
    this.delayed_in_reporting = delayed_in_reporting;
  }
}
class RePayCardInfo {
  country;
  bank_name;
  brand;
  category;
  type;
  constructor({ country, bank_name, brand, category, type }) {
    this.country = country;
    this.bank_name = bank_name;
    this.brand = brand;
    this.category = category;
    this.type = type;
  }
}
